import React, { useEffect, useState } from 'react';
import { deleteReceivedDocument, getDocuments, getDocumentsSendStatus, getReceivedDocDeleteStatus, loadDocuments, receviedDocDeleted, sendDocuments } from '../app/store/documents';
import { useDispatch, useSelector } from 'react-redux';
import CandidateReqDoc from '../components/OMCRegistry/CandidateReqDoc';
import useDocDownload from '../app/hooks/useDocDownload';
import { getAlert, getConfirmAlert, getConfirmAlertWithAuth } from '../services/appAlerts';
import { getCurrentUser } from '../app/store/auth';

export default function ReportingDocuments(props) {
    const { workflowTask, item } = props;
    const [reportingDocs, setReportingDocs] = useState([]);
    const [uploadDocType, setUploadDocType] = useState("");
    const [sendType, setSendType] = useState("");
    const [docShowHide, setDocShowHide] = useState(false);
    const [deleteType, setDeleteType] = useState("");

    const [handleDownloadFile] = useDocDownload();

    const documentsSelector = useSelector(getDocuments);
    const receivedDocDeleteStatusSelector = useSelector(getReceivedDocDeleteStatus);
    const documentSendStatusSelector = useSelector(getDocumentsSendStatus);


    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (workflowTask?.ciid > 0) {
            dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [workflowTask])

    useEffect(() => {
        if (documentsSelector.length > 0) {
            const rptDocs = documentsSelector.filter(x => x.uploadType === "reporting" && x.deleteFlag !== true);
            setReportingDocs(rptDocs);
        } else {
            setReportingDocs([]);
        }
    }, [documentsSelector])



    const handleDocShowHide = (type, dType) => {
        if (type === "save") {
            setDocShowHide(false);
            setSendType("");
            setUploadDocType("");
            if (workflowTask?.ciid > 0)
                dispatch(loadDocuments(workflowTask.ciid));
        } else {
            setDocShowHide(!docShowHide);
            setSendType(type);
            if (dType) setUploadDocType(dType);
        }
    };

    const handleDeleteFile = async (docId, type) => {
        const confirmDelete = await getConfirmAlertWithAuth(
            "",
            "Are you sure you want to delete this document?",
            "warning"
        );

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReceivedDocument(docId, type));
            setDeleteType(type);
        }
    };

    useEffect(() => {
        if (receivedDocDeleteStatusSelector) {
            getAlert("", "Document deleted successfully", "success");
            setDeleteType("");
            dispatch(receviedDocDeleted(null));
            // Refresh document lists after deletion
            if (deleteType === "doc")
                dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [receivedDocDeleteStatusSelector]);

    const handleSendDoc = async (id) => {
        const docIds = [id];
        const frm = new FormData();
        frm.append("ids", docIds);
        frm.append("userId", currentUser.id);
        frm.append("ciid", workflowTask?.ciid);
        const result = await getConfirmAlert(
            "Warning",
            "Are you sure you want to send this Document?",
            "warning"
        );
        if (result.isConfirmed) dispatch(sendDocuments(frm));

    };

    useEffect(() => {
        if (documentSendStatusSelector && workflowTask?.ciid) {
            getAlert("", "Document Sent Successfully", "success");
            dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [documentSendStatusSelector]);


    return (
        <>
            <table className="table table-striped align-items-center table-flush border mb-0 mt-2">
                <thead className="thead-light-green">
                    <tr>
                        <th><button
                            type="button"
                            className="btn btn-sm btn-outline-default"
                            onClick={() => handleDocShowHide("upload", "reporting")}
                        >
                            <i className="fa fa-paperclip mr-1"></i> Upload
                        </button></th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {reportingDocs.map(doc =>
                        <tr>
                            <td className="text-wrap">
                                <button
                                    className="btn btn-sm btn-link pl-0 text-wrap text-left"
                                    title="Download File"
                                    onClick={() => handleDownloadFile(doc)}
                                >
                                    {doc.docName}
                                </button>
                            </td>
                            <td>
                                {!doc.sentStatus ?
                                    <button
                                        className="btn btn-sm btn-link"
                                        onClick={() => handleSendDoc(doc.docId)}
                                    >
                                        Send
                                    </button> : "Sent"}
                                <button
                                    className="btn btn-sm btn-link text-danger"
                                    title="Delete File"
                                    onClick={() => handleDeleteFile(doc.docId, "doc")}
                                >
                                    <i className="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>

                    )}
                </tbody>
            </table>

            {docShowHide && (
                <CandidateReqDoc
                    docShowHide={docShowHide}
                    handleDocShowHide={handleDocShowHide}
                    workItem={workflowTask}
                    sendType={sendType}
                    uploadType={"reporting"}
                    applicantObj={item}
                    viewType={""}
                    uploadDocType={uploadDocType}
                ></CandidateReqDoc>
            )}
        </>
    );
}